import { render, staticRenderFns } from "./OptionLinkSettings.vue?vue&type=template&id=2ed084fc&scoped=true"
import script from "./OptionLinkSettings.vue?vue&type=script&lang=js"
export * from "./OptionLinkSettings.vue?vue&type=script&lang=js"
import style0 from "./OptionLinkSettings.vue?vue&type=style&index=0&id=2ed084fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed084fc",
  null
  
)

export default component.exports